import React, { useRef, useEffect, useContext, useState } from 'react';
import { Box, Image, Text } from 'theme-ui';
import { store } from '../../../../../gatsby-theme-minimal/src/Context/Store';
import { Link } from 'gatsby';
import useStoriesStatic from '../../../../../gatsby-theme-minimal/src/hooks/useStoriesStatic';
export default function ShadowerComponent({ story, stories, ...rest }) {
  const { globalState, dispatch } = useContext(store);
  const heroStory = useStoriesStatic(story)?.[0];
  const storyList = useStoriesStatic(stories);
  const heroStoryImage = {
    backgroundImage: `url(https://res.cloudinary.com/gonation/e_brightness:-45/${heroStory?.media?.[0]?.cloudinaryId})`,
  };

  const [displayedSlideIndex, setDisplayedSlideIndex] = useState(false);

  const renderButtons = () => {
    return storyList
      .sort((a, b) => (a < b ? -1 : 1))
      .map(({ ctaLink }, index) => {
        return (
          <Box sx={styles.box}>
            <Link
              key={`${ctaLink.name + index}`}
              to={ctaLink.url}
              onMouseEnter={e => setDisplayedSlideIndex(index)}
              onMouseLeave={e => setDisplayedSlideIndex(false)}
            >
              {ctaLink.title}
            </Link>
          </Box>
        );
      });
  };

  const renderImages = () =>
    storyList
      .sort((a, b) => (a < b ? 1 : -1))
      .map(({ media }, index) => {
        const backgroundImageStyles =
          displayedSlideIndex === index
            ? {
                opacity: '1',
                transform: 'scale(1.1)',
                zIndex: '100',
              }
            : {};

        const image = `https://res.cloudinary.com/gonation/${media[0].cloudinaryId}`;
        return (
          <Image
            key={`heroimage${index}`}
            sx={{ ...styles.buttonImage, ...backgroundImageStyles }}
            src={image}
          />
        );
      });

  return (
    <Box sx={{ ...styles.container, ...heroStoryImage }}>
      <Box sx={{ ...styles.ImageContainer }}>{renderImages()}</Box>

      <Box sx={styles.content}>
        {heroStory.title ? <h1>{heroStory.title}</h1> : ''}
        {heroStory.subtitle ? <h2>{heroStory.subtitle}</h2> : ''}
        <Link className="heroLink" to={heroStory.ctaLink.url} target="__blank">
          {heroStory.ctaLink.title}
        </Link>
        <Box sx={styles.boxes}>{renderButtons()}</Box>
      </Box>
    </Box>
  );
}

const styles = {
  container: {
    height: '100vh',
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
    backgroundSize: 'cover',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: '100',

    h1: {
      textTransform: 'uppercase',
      fontWeight: 'bold',
      fontSize: ['2rem', '2.5rem', '3rem', '4rem'],
      fontFamily: 'heading',
      margin: ['1rem', '', '2rem'],
      color: 'white',
    },

    '.heroLink': {
      border: 'solid 2px white',
      padding: '0.7rem 2rem',
      color: 'white',
      cursor: 'pointer',
      transition: 'all ease-in-out 0.6s',
      ':hover': {
        backgroundColor: 'primary',
        transform: 'scale(1.1)',
      },
    },

    // position: 'absolute',
    // top: '20%',
    // left: '50%',
    // transform: 'translate(-50%,-50%)',
    // color: 'white',
    // textAlign: 'center',
    // fontWeight: 'bold',
    // textTransform: 'uppercase',
    // letterSpacing: '1px',
    // zIndex: '300',
    // width: '100%',
  },
  boxes: {
    // position: 'absolute',
    // left: '50%',
    // top: '50%',
    // transform: 'translate(-50%, -50%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',

    width: 'fit-content',
  },
  box: {
    flexGrow: '1',
    width: '20',
    height: 'fit-content',
    padding: '1rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'uppercase',
    fontWeight: '700',
    fontSize: ['2rem', '2.5rem', '3rem', '4rem'],
    transition: 'all ease-in-out 1s',
    fontFamily: 'heading',
    margin: ['1rem', '', '2rem'],
    color: '#e8d6c4',
    ':hover': {
      // height: '100px',
      transform: 'scale(1.1)',
    },
  },

  ImageContainer: {
    transition: 'all ease-in-out 1s',
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: '0',
    top: '0',
  },
  buttonImage: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    transition: 'all ease-in-out 0.75s',
    left: '0',
    top: '0',
    objectFit: 'cover',
    filter: 'brightness(0.6)',
    opacity: '0',
    display: 'flex',
  },
};

ShadowerComponent.defaultProps = {
  story: 'a-art-SWpBK3n3SLScwFZilMV-4g',
  stories: [
    'a-art-rMbz9DSnSV6yFSgPt2bK3A',
    'a-art-3Xc20GdOT4G_w3P8CTRL4w',
    'a-art-SnY0FUDKT7qETG5weCj_GQ',
  ],
};
